/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
import Moment from "react-moment";
import axios from "axios";
import { Col, Row, Form, Button } from "react-bootstrap";

const ClassUpdate = (props) => {
  const classid = props.data._id;
  //Manage States
  const [selectedClassType, setSelectedClassType] = useState("");
  const [MaxLearners, setMaxLearners] = useState(props.data.MaxLearners);
  const [StartDate, setStartDate] = useState(props.data.StartDate);
  const [StartTime, setStartTime] = useState(props.data.StartTime);
  const [FinishTime, setFinishTime] = useState(props.data.FinishTime);
  const [Day, setDay] = useState(props.data.Day);
  const [Price, setPrice] = useState(props.data.Price);
  // Toggle Proration
  const toggleProration = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let Prorate;
    if (props.data.Prorate) {
      Prorate = false;
    } else {
      Prorate = true;
    }
    const prorateToggle = await axios.put(
      `/api/admin/edit_class/toggle_proration/regular`,
      {
        _id: classid,
        Prorate,
      },
      {
        withCredentials: true,
      }
    );
    if (prorateToggle.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully toggled.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  //Toggle Month Start Billing
  const toggleMonthStartBilling = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let monthStartBilling;
    if (props.data.monthStartBilling) {
      monthStartBilling = false;
    } else {
      monthStartBilling = true;
    }
    const prorateToggle = await axios.put(
      `/api/admin/edit_class/toggle_month_start_billing/`,
      {
        _id: classid,
        monthStartBilling,
      },
      {
        withCredentials: true,
      }
    );
    if (prorateToggle.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully toggled.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Toggle Visibility
  const toggleVisibility = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    let isHiddenFromSchedule;
    if (props.data.isHiddenFromSchedule === "public") {
      isHiddenFromSchedule = "hidden";
    } else {
      isHiddenFromSchedule = "public";
    }
    const visibilityToggle = await axios.put(
      `/api/admin/edit_class/toggle_visibility/regular`,
      {
        _id: classid,
        isHiddenFromSchedule,
      },
      {
        withCredentials: true,
      }
    );
    if (visibilityToggle.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully toggled.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Class Type
  const changeClassType = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
     // Get the relevant class data to submit
     const fetchClassType = props.classTypes.find( types => {
      return types._id === selectedClassType;
    })
    // Construct the data Packet
    const data = {
      classid,
      LessonType: fetchClassType.Type,
      ShortDescription: fetchClassType.ShortDescription,
      LowerAgeString: fetchClassType.LowerAgeString,
      UpperAgeString: fetchClassType.UpperAgeString,
      GradingList: fetchClassType.GradingList,
    };
    // Set the new Class Data
    const setNewClassType = await axios.put(`/api/admin/edit_class/class_type/regular`, data, {
      withCredentials: true,
    });
    // handle the response
    if (setNewClassType.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed class type.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Capacity
  const handleCapacityChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestMaxLearnerChange = await axios.put(
      `/api/admin/edit_class/capacity/regular`,
      { classid, MaxLearners },
      {
        withCredentials: true,
      }
    );
    if (requestMaxLearnerChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed class capacity.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Start Date
  const handleStartDateChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestStartDateChange = await axios.put(
      `/api/admin/edit_class/start_date/`,
      { classid, StartDate },
      {
        withCredentials: true,
      }
    );
    if (requestStartDateChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed start date.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Start Date
  const handleTimeAndDaySubmit = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const requestTimeChange = await axios.put(
      `/api/admin/edit_class/time/`,
      { classid, Day, FinishTime, StartTime },
      {
        withCredentials: true,
      }
    );
    if (requestTimeChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully changed class time.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  // Change Start Date
  const handlePriceChange = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const data = {
      classid,
      newPrice: Price,
    };
    const requestPriceChange = await axios.post(
      `/api/admin/manage_prices/update_stripe_product/`,
      data,
      {
        withCredentials: true,
      }
    );
    if (requestPriceChange.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully updated class price.");
      return setTimeout(() => props.fetchNewData(), 1000); // Wait for stripe webhook to resolve.
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <>
      <Row className='border mt-4 text-center'>
        <Col className='mt-2 mb-2'>
          <h2>Edit Class Details</h2>
          <span className='mt-2'>
            You can edit your class details here. Editing class details will not inform participants
            of changes.
          </span>
        </Col>
      </Row>
      <Row className='mt-2 text-center'>
        <Col lg='4'>
          <Form onSubmit={toggleProration} className='mt-2 mb-2 border p-3 shadow'>
            <Form.Group controlId='CapacityForm'>
              <Form.Label className='d-block'>Toggle Proration</Form.Label>
              <Form.Text className='text-muted'>
                <small>
                  Proration behaviour determines if Signaclass creates a covering payment to account
                  for lessons which are yet to happen in the month the customer subscribes.
                </small>
              </Form.Text>
            </Form.Group>
            {props.data.Prorate ? (
              <Button
                variant='danger'
                className=' mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Disable Proration
              </Button>
            ) : (
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Enable Proration
              </Button>
            )}
          </Form>
        </Col>
        <Col lg='4'>
          <Form onSubmit={toggleMonthStartBilling} className='mt-2 mb-2 border p-3 shadow'>
            <Form.Group controlId='CapacityForm'>
              <Form.Label className='d-block'>Month Start Billing</Form.Label>
              <Form.Text className='text-muted'>
                <small>
                  Month start billing will attempt to ensure customers are always billed for a whole
                  month regardless of what time they sign up, unless proration is off in which case
                  it only affects classes which have not yet started.
                </small>
              </Form.Text>
            </Form.Group>
            {props.data.monthStartBilling ? (
              <Button
                variant='danger'
                className=' mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Disable MSB
              </Button>
            ) : (
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Enable MSB
              </Button>
            )}
          </Form>
        </Col>

        <Col lg='4'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={toggleVisibility}>
            <Form.Group controlId='CapacityForm'>
              <Form.Label className='d-block'>Toggle Visibility</Form.Label>
              <Form.Text className='text-muted'>
                <small>
                  Toggling class visibility allows you to remove a session from the public timetable
                  but keep it active. It might be useful if you no longer want to advertise a class
                  or want to offer private classes. Class Signup and checkout links still work.
                </small>
              </Form.Text>
            </Form.Group>
            {props.data.isHiddenFromSchedule === "public" ? (
              <Button
                variant='danger'
                className=' mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Hide Class
              </Button>
            ) : (
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Unhide Class
              </Button>
            )}
          </Form>
        </Col>
      </Row>
      <Row className='mt-4 text-center'>
        <Col lg='4'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={changeClassType}>
            <Form.Group controlId='selectClassType'>
              <Form.Label>Change Class Type</Form.Label>
              <Form.Control
                as='select'
                value={selectedClassType}
                onChange={(e) => setSelectedClassType(e.target.value)}
                required
                custom
              >
                <option value='' disabled defaultValue>
                  Select your option
                </option>
                {props.classTypes.map((ClassType) => (
                  <option key={ClassType._id} value={ClassType._id}>
                    {ClassType.Type}
                  </option>
                ))}
              </Form.Control>
              <Form.Text className='text-muted'>The type of lesson this is.</Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change
            </Button>
          </Form>
        </Col>
        <Col lg='4'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={handleCapacityChange}>
            <Form.Group controlId='CapacityForm'>
              <Form.Label>Change Capacity</Form.Label>
              <Form.Control
                type='number'
                min='0'
                max='100'
                value={MaxLearners}
                onChange={(e) => setMaxLearners(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                The maximum number of participants for this session.
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change
            </Button>
          </Form>
        </Col>
        <Col lg='4'>
          <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={handleStartDateChange}>
            <Form.Group controlId='StartDateForm'>
              <Form.Label>Change Start Date</Form.Label>
              <Form.Control
                type='date'
                value={StartDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                Currently: <Moment format='DD MMMM YYYY'>{props.data.StartDate}</Moment>
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change
            </Button>
          </Form>
        </Col>
      </Row>
      <div className='mt-4 text-center'>
        <Form className='mt-2 mb-2 border p-3 shadow' onSubmit={handleTimeAndDaySubmit}>
          <Row>
            <Col lg='4' className='mt-2 mb-2 p-3'>
              <Form.Group controlId='SelectCustomForm'>
                <Form.Label>Day of Session</Form.Label>
                <Form.Control
                  as='select'
                  value={Day}
                  onChange={(e) => setDay(e.target.value)}
                  custom
                  required
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value='Monday'>Monday</option>
                  <option value='Tuesday'>Tuesday</option>
                  <option value='Wednesday'>Wednesday</option>
                  <option value='Thursday'>Thursday</option>
                  <option value='Friday'>Friday</option>
                  <option value='Saturday'>Saturday</option>
                  <option value='Sunday'>Sunday</option>
                </Form.Control>
                <Form.Text className='text-muted'>The day the session will be held.</Form.Text>
              </Form.Group>
            </Col>

            <Col lg='4' className='mt-2 mb-2 p-3'>
              <Form.Group controlId='StartTimeForm'>
                <Form.Label>Start Time</Form.Label>
                <Form.Control
                  type='time'
                  value={StartTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  required
                />
                <Form.Text className='text-muted'>The start time of the session.</Form.Text>
              </Form.Group>
            </Col>

            <Col lg='4' className='mt-2 mb-2 p-3'>
              <Form.Group controlId='EndTimeForm'>
                <Form.Label>Ending Time</Form.Label>
                <Form.Control
                  type='time'
                  value={FinishTime}
                  onChange={(e) => setFinishTime(e.target.value)}
                  required
                />
                <Form.Text className='text-muted'>The end time of the session.</Form.Text>
              </Form.Group>
            </Col>
            <Col lg='12'>
              <Button
                variant='primary'
                className='mt-3 mb-4'
                type='submit'
                onClick={props.scrollSmoothHandler}
                disabled={props.submitClicked}
              >
                Change
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <Row className='mt-4 mb-4 text-center'>
        <Col sm='12'>
          <Form className='border p-3 shadow' onSubmit={handlePriceChange}>
            <Form.Group controlId='PriceForm'>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type='number'
                min='0'
                max='1000'
                step='0.01'
                placeholder='10.50'
                value={Price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
              <Form.Text className='text-muted'>
                Setting a new price changes the price for existing subscribers from the next billing
                date.
              </Form.Text>
            </Form.Group>
            <Button
              variant='primary'
              className='mt-3 mb-4'
              type='submit'
              onClick={props.scrollSmoothHandler}
              disabled={props.submitClicked}
            >
              Change Price
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default ClassUpdate;
